import React from 'react'
import styled from 'styled-components'
import logo from '../../../../assets/img/logo.png'
import busFooter from '../../../../assets/img/bus-footer.png'
import SocialItem from './components/social-item/social-item'
import { Facebook } from '@styled-icons/boxicons-logos'
import { Twitter } from '@styled-icons/boxicons-logos'
import { Youtube } from '@styled-icons/boxicons-logos'
import { device } from '../../../../config/theme/breakpoints'
import SectionTC from '../../../../components/section-tc/section-tc'
import { agencyList, companyList } from './data-footer'
import { Link } from 'react-router-dom'
import { Location }from '@styled-icons/fluentui-system-regular'
import { AlternateEmail }from '@styled-icons/material'
import ListPaymentFooter from './components/list-payment-footer/list-payment-footer'
import ButtonTC from '../../../../components/button-tc/button-tc'
import { Question } from '@styled-icons/evil'
import { NavLink } from 'react-router-dom'

const DivCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const FooterWrapper = styled.div`
  overflow: hidden;
  margin-top: 60px;
`

const ContainerLinks = styled.div`
  width: 100%;
  background: #F2F2F2;
  padding: 40px 10px;
  min-height: 100px;
  border-radius: 0 300px 0 0;
  position: relative;
`

const ContainerSocial = styled(DivCenter)`
  flex-direction: column;
  align-items: center;
  width: 100%;

  > div img{
    max-width: 250px;
  }

  > p{
    color: ${p => p.theme.palette.text.gray};
    margin-top: 20px;
    margin-bottom: 20px;
  }

  @media ${device.tablet}{
    align-items: flex-start;
    width: 38%;
  }
`
  
const ContainerCompany = styled(DivCenter)`
  width: 100%;
  flex-direction: column;
  
  > div a{
    text-decoration: none;
    display: block;
    margin-top: 15px;
    margin-bottom: 15px;
    color: ${p => p.theme.palette.text.black};

    :hover{
      color: ${p => p.theme.palette.text.secondary};
    }
  }

  > h3{
    color: ${p => p.theme.palette.text.primary};
    margin: 0;
  }

  @media ${device.tablet}{
    width: 50%;
  }
`

const ContainerAgency = styled(DivCenter)`
  width: 100%;
  flex-direction: column;
  
  > div a{
    text-decoration: none;
    display: block;
    margin-top: 15px;
    margin-bottom: 15px;
    color: ${p => p.theme.palette.text.black};

    :hover{
      color: ${p => p.theme.palette.text.secondary};
    }
  }

  > h3{
    color: ${p => p.theme.palette.text.primary};
    margin: 0;
  }

  @media ${device.tablet}{
    width: 50%;
  }
`

const ContainerLocation = styled(DivCenter)`
  flex-direction: column;
  width: 100%;

  > h3{
    align-self: center;
    margin: 0;
    color: ${p => p.theme.palette.text.primary};

    @media ${device.tablet}{
      align-self: flex-start;
    }
  }

  > div{
    padding-left: 15px;
  }
  
  > div p{
    display: flex;
    flex-direction: row;

    > p{
      margin: 0;
      color: ${p => p.theme.palette.text.black};
    }

    > div{
      margin-right: 15px;
    }
  }

  @media ${device.tablet}{
    width: 28%;
  }
`

const SocialList = styled(DivCenter)`
  gap: 12px;
`
const ContainerPolicies = styled.div`
  width: 100%;
  min-height: 30px;
  background: red;
  padding: 6px 10px;
  color: white;
  position: relative;
  z-index: 1;
`
const ContainerTerms = styled(DivCenter)`
  gap: 0;
  flex-direction: column;

  > a {
    margin: 10px 0;
    color: white;
    text-decoration: none;
  }

  @media ${device.mobileL}{
    flex-direction: row;
    gap: 20px;
  }
`
const ContainerCenter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  width: 100%;

  @media ${device.tablet}{
    width: 28%;
  }
`
const CustomSectionHeader = `
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  position: relative;
  gap: 20px;
  z-index: 1;
`

const CustomBottomFooter = `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media ${device.tablet}{
    flex-direction: row;
    justify-content: space-between;
  }
`

const ContainerHelp = styled.div`
  position: absolute;
  right: 0;
  max-height: 115px;
  top: 24%;
  display: none;

  > div img{
    max-width: 200px;
  }

  > div div{
    position: relative;
    z-index: 3;
  }

  @media ${device.laptop}{
    display: flex;
  }
`

const Footer: React.FunctionComponent = () => {
  return (
    <FooterWrapper>
      <ContainerLinks>
        <SectionTC className={CustomSectionHeader}>
          <ContainerSocial>
            <div><img src={logo} alt='logo' /></div>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <SocialList>
              <SocialItem icon={<Facebook />}/>
              <SocialItem icon={<Twitter />}/>
              <SocialItem icon={<Youtube />}/>
            </SocialList>
          </ContainerSocial>
          <ContainerCenter>
            <ContainerCompany>
              <h3>Empresa</h3>
              <div>
                {companyList.map(company => (
                  <Link key={company.id} to={company.path}>{company.name}</Link>
                ))}
              </div>
            </ContainerCompany>
            <ContainerAgency>
              <h3>Agencias</h3>
              <div>
                {agencyList.map(agency => (
                  <Link key={agency.id} to={agency.path}>{agency.name}</Link>
                ))}
              </div>
            </ContainerAgency>
          </ContainerCenter>
          <ContainerLocation>
            <h3>Paga con</h3>
            <ListPaymentFooter />
            <div>
              <p>
                <SocialItem icon={<Location />}/>
                <p>Av. Jose Leonardo Ortiz N° 010 Chiclayo</p>
              </p>
              <p>
                <SocialItem icon={<AlternateEmail />}/>
                <p>Correo atencionalcliente@transporteschiclayo.pe</p>
              </p>
            </div>
          </ContainerLocation>
        </SectionTC>
        <ContainerHelp>
          <div>
            <ButtonTC text='Necesitas ayuda' icon={<Question />}/>
            <img src={busFooter} alt="carro" />
          </div>
        </ContainerHelp>
      </ContainerLinks>
      <ContainerPolicies>
        <SectionTC className={CustomBottomFooter}>
          <p>© Copyright 2022 Transportes Chiclayo</p>
          <ContainerTerms>
            <NavLink to='/libro-de-reclamaciones'>Libro de reclamaciones</NavLink>
            <NavLink to='/preguntas-frecuentes'>Preguntas frecuentes</NavLink>
            <NavLink to='/politicas-de-privacidad'>Politicas de privacidad</NavLink>
            <NavLink to='/terminos-y-condiciones'>Terminos de servicio</NavLink>
          </ContainerTerms>
        </SectionTC>
      </ContainerPolicies>
    </FooterWrapper>
  )
}

export default Footer